import React from "react";
import { Skeleton } from "src/@/components/ui/skeleton"; // Certifique-se de instalar e importar corretamente

export default function CalendarSkeleton() {
  return (
    <div className="flex gap-4 mt-4">
      {/* Sidebar Skeleton */}
      <div className="w-1/5 space-y-6">
        {/* Botão Criar Evento */}
        <Skeleton className="h-10 w-1/2 bg-slate-100" />
        
        {/* Categorias */}
        <div className="space-y-3">
          <Skeleton className="h-4 w-3/4 bg-slate-100" />
          <Skeleton className="h-4 w-1/2 bg-slate-100" />
        </div>

        {/* Próximos Eventos */}
        <div className="space-y-4">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>

      {/* Main Calendar Skeleton */}
      <div className="w-3/4 space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <Skeleton className="h-6 w-1/4" />
          <Skeleton className="h-6 w-1/5" />
        </div>

        {/* Calendar Grid */}
        <div className="grid grid-cols-6 gap-4">
          {Array.from({ length: 40 }).map((_, index) => (
            <Skeleton key={index} className="h-24 w-full bg-slate-200" />
          ))}
        </div>
      </div>
    </div>
  );
}
